/** @flow */

import {
  GetReasonSpecificScripts,
  GetReasonSpecificScriptsSuccess,
  NewReasonSpecificScript,
  NewReasonSpecificScriptAssignments,
  ShowAddReasonSpecificScriptModal,
  UpdateReasonSpecificScriptDraft,
  SetReasonSpecificScriptAssignments,
  GetReasonSpecificScriptActiveSuccess,
  ShowReasonSpecificScriptEditModal,
  SetShowDiscardReasonSpecificScriptModal,
  SetShowCancelReasonSpecificScriptModal,
  SetShowCancelDiscardReasonSpecificScriptModal,
  StartReasonSpecificScriptDraftSuccess,
  DuplicateReasonSpecificScriptSuccess,
  SetShowDisableReasonSpecificScriptModal,
  ShowEditReasonSpecificScriptAssignmentsModal,
  SetReasonSpecificScriptDraft,
  SetShowSubmitReasonSpecificScriptModal,
  SetReasonSpecificScriptDraftAssignments,
  GetReasonSpecificScript,
  GetReasonSpecificScriptSuccess,
  GetReasonSpecificScriptError,
  UpdateReasonSpecificScript,
  UpdateReasonSpecificScriptSuccess,
  UpdateReasonSpecificScriptError,
} from "@modules/service/constants/actions";
import * as reasonSpecificScriptsReducers from "./reducers";
import initialState from "./state";
import type { ReasonSpecificScriptsState } from "./types";
import { cloneObject } from "@utils/object";

export default (
  state: ReasonSpecificScriptsState = initialState,
  action: Object,
): ReasonSpecificScriptsState => {
  const act = {
    [UpdateReasonSpecificScript]: reasonSpecificScriptsReducers.onUpdateReasonSpecificScript,
    [UpdateReasonSpecificScriptSuccess]:
      reasonSpecificScriptsReducers.onUpdateReasonSpecificScriptSuccess,
    [UpdateReasonSpecificScriptError]:
      reasonSpecificScriptsReducers.onUpdateReasonSpecificScriptError,
    [GetReasonSpecificScript]: reasonSpecificScriptsReducers.onGetReasonSpecificScript,
    [GetReasonSpecificScriptSuccess]:
      reasonSpecificScriptsReducers.onGetReasonSpecificScriptSuccess,
    [GetReasonSpecificScriptError]: reasonSpecificScriptsReducers.onGetReasonSpecificScriptError,
    [GetReasonSpecificScripts]: reasonSpecificScriptsReducers.onGetReasonSpecificScripts,
    [GetReasonSpecificScriptsSuccess]:
      reasonSpecificScriptsReducers.onGetReasonSpecificScriptsSuccess,
    [NewReasonSpecificScript]: reasonSpecificScriptsReducers.onNewReasonSpecificScript,
    [NewReasonSpecificScriptAssignments]:
      reasonSpecificScriptsReducers.onNewReasonSpecificScriptAssignments,
    [ShowAddReasonSpecificScriptModal]:
      reasonSpecificScriptsReducers.onShowAddReasonSpecificScriptModal,
    [UpdateReasonSpecificScriptDraft]:
      reasonSpecificScriptsReducers.onUpdateReasonSpecificScriptDraft,
    [SetReasonSpecificScriptAssignments]:
      reasonSpecificScriptsReducers.onSetReasonSpecificScriptAssignments,
    [SetReasonSpecificScriptDraftAssignments]:
      reasonSpecificScriptsReducers.onSetReasonSpecificScriptDraftAssignments,
    [GetReasonSpecificScriptActiveSuccess]:
      reasonSpecificScriptsReducers.onGetReasonSpecificScriptActiveSuccess,
    [ShowReasonSpecificScriptEditModal]:
      reasonSpecificScriptsReducers.onShowReasonSpecificScriptEditModal,
    [SetShowDiscardReasonSpecificScriptModal]:
      reasonSpecificScriptsReducers.onSetShowDiscardReasonSpecificScriptModal,
    [SetShowCancelReasonSpecificScriptModal]:
      reasonSpecificScriptsReducers.onSetShowCancelReasonSpecificScriptModal,
    [SetShowCancelDiscardReasonSpecificScriptModal]:
      reasonSpecificScriptsReducers.onSetShowCancelDiscardReasonSpecificScriptModal,
    [SetShowDisableReasonSpecificScriptModal]:
      reasonSpecificScriptsReducers.onSetShowDisableReasonSpecificScriptModal,
    [SetShowSubmitReasonSpecificScriptModal]:
      reasonSpecificScriptsReducers.onSetShowSubmitReasonSpecificScriptModal,
    [ShowEditReasonSpecificScriptAssignmentsModal]:
      reasonSpecificScriptsReducers.onShowEditReasonSpecificScriptAssignmentsModal,
    [StartReasonSpecificScriptDraftSuccess]:
      reasonSpecificScriptsReducers.onStartReasonSpecificScriptDraftSuccess,
    [DuplicateReasonSpecificScriptSuccess]:
      reasonSpecificScriptsReducers.onDuplicateReasonSpecificScriptSuccess,
    [GetReasonSpecificScriptSuccess]:
      reasonSpecificScriptsReducers.onGetReasonSpecificScriptSuccess,
    [SetReasonSpecificScriptDraft]: reasonSpecificScriptsReducers.onSetReasonSpecificScriptDraft,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
